import axios from "axios";
import moment from "moment";
import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../baseUrl";
import Spinner from "../../Components/Spinner/Spinner";
import { Tooltip } from "@material-tailwind/react";
import EditLabtest from "./EditLabtest";

const AllLabtest = () => {
  const navigate = useNavigate();

  const [labtests, setLabtests] = useState([]);
  const token = JSON.parse(localStorage.getItem("admin-token"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${baseUrl}/admin/all-labtests`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setLabtests(res.data.labtests);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  console.log(labtests);
  return (
    <>
      {loading && <Spinner />}
      <nav
        className="container text-black font-bold mx-5 my-4"
        aria-label="Breadcrumb"
      >
        <h3 className="text-gray-700 text-3xl font-medium">All labtests</h3>
      </nav>

      <div className="container mx-auto px-6 py-3">
        <div className="flex flex-col">
          <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
              {labtests.length <= 0 ? (
                <h1 className="text-center text-3xl">
                  <Spinner /> No labtests
                </h1>
              ) : (
                <table className="min-w-full">
                  <thead>
                    <tr>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Full name
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        test type
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        test date
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        status
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Result
                      </th>
                      <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody className="bg-white">
                    {labtests.map((labtest) => (
                      <tr key={labtest._id}>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          <Tooltip
                            className="bg-indigo-900 p-4 text-white"
                            content={labtest.feedback}
                          >
                            <div className="text-sm leading-5 text-gray-900">
                              {labtest.userId.fullname} | {labtest.userId.email}
                            </div>
                          </Tooltip>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          <div className="text-sm leading-5 text-gray-900">
                            {labtest.labtestType}
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold text-gray-500">
                            {moment(labtest.createdAt).format("MMM Do YYYY")}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                          {labtest.status}
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                          {labtest.result}
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 font-medium">
                          <EditLabtest labtest={labtest} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AllLabtest;
